import React, { useState } from 'react';
import { FaShoppingCart, FaSearch } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import KitchenCartModal from './KitchenCartModal';
import { useKitchenCart } from '../context/KitchenCartContext';

const KitchenHeader = ({ searchQuery, setSearchQuery, cartCount }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isKitchenPage = location.pathname === '/kitchen';
  const isCheckoutPage = location.pathname === '/kitchen/checkout';
  const [showCartModal, setShowCartModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { cartItems } = useKitchenCart();

  const toggleCartModal = () => {
    setShowCartModal(!showCartModal);
  };

  // Handle checkout - navigate to kitchen checkout page
  const handleCheckout = () => {
    if (cartItems.length === 0) return;
    
    setIsLoading(true);
    sessionStorage.setItem('kitchenCartData', JSON.stringify(cartItems));
    setShowCartModal(false);
    setIsLoading(false);
    navigate('/kitchen/checkout');
  };

  return (
    <>
      <header className={`header ${isCheckoutPage ? 'payment-header' : ''}`}>
        <div className={`logo ${isCheckoutPage ? 'centered-logo' : ''}`}>
          <img src="/assets/images/logo.png" alt="Kitchen & Bar" className="logo-image" />
          <span className="logo-subtitle">Kitchen & Bar</span>
        </div>
        {isKitchenPage && (
          <div className="search-bar">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search menu..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        )}
        {!isCheckoutPage && (
          <div className="cart-icon" onClick={toggleCartModal}>
            <FaShoppingCart />
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </div>
        )}
      </header>
      
      <KitchenCartModal 
        isOpen={showCartModal} 
        onClose={() => setShowCartModal(false)}
        onCheckout={handleCheckout}
        isLoading={isLoading}
      />
    </>
  );
};

export default KitchenHeader;
